import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  BodyText,
  IllusSupplyChain,
  Image,
  Rating,
  theme,
  TitleText,
  useResponsive,
} from '@sweetgreen/garnish';

export const LandingContent = React.memo((props: LandingContentProps) => {
  const {
    ratingTitle,
    landingTitle,
    landingSubtitle,
    rating,
    onHoverRating,
    onRating,
  } = props;

  const { match } = useResponsive();

  return (
    <View style={styles.content}>
      <Image
        style={styles.image}
        source={IllusSupplyChain}
        accessibilityIgnoresInvertColors
        resizeMode="cover"
      />

      <TitleText style={styles.title} size={5}>
        {landingTitle}
      </TitleText>

      {landingSubtitle ? (
        <BodyText style={styles.subtitle} size={match([1, 2])}>
          {landingSubtitle}
        </BodyText>
      ) : null}

      <Rating value={rating} onChange={onRating} onHover={onHoverRating} />

      <BodyText style={styles.ratingTitle}>{ratingTitle}</BodyText>
    </View>
  );
});

type LandingContentProps = {
  readonly ratingTitle: string;
  readonly landingTitle: string;
  readonly landingSubtitle: string;
  readonly rating: number;
  readonly onHoverRating: (rating: number) => void;
  readonly onRating: (rating: number) => void;
};

const styles = StyleSheet.create({
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: theme.spacing.xlarge,
    paddingBottom: theme.spacing.large,
  },
  image: {
    width: 280,
    height: 166,
    marginBottom: theme.spacing.medium,
  },
  title: {
    textAlign: 'center',
    marginBottom: theme.spacing.medium,
  },
  subtitle: {
    color: theme.colors.CHARCOAL,
    textAlign: 'center',
    marginBottom: theme.spacing.medium,
  },
  ratingTitle: {
    marginTop: theme.spacing.medium,
    color: theme.colors.KALE,
  },
});
